<template>
  <div style="margin-top: 46px">
    <div style="text-align: center; background-color: #fff; font-weight: 600; padding: 10px 0">考试名称：{{ examInfo.quizName }}</div>
    <div class="examInfo">
      <div class="fm">
        <img :src="examInfo.quizImage"
             alt="" />
      </div>
      <div style="margin-left: 10px">
        <div class="t1">总分/及格分： {{ examInfo.totalPoint }}/{{ examInfo.passscore }}分</div>
        <div class="t1">考试时长：{{ examInfo.timelimit }}分钟</div>
        <div class="t1"
             v-show="examInfo.maxallowed !== 0">最大答题次数：{{ examInfo.maxallowed }}</div>
        <div class="t1"
             v-show="examInfo.maxallowed == 0">最大答题次数：无限制</div>
        <div class="t1">继续答题：{{ examInfo.attemptonlast == '02' ? '允许' : '不允许' }}</div>
        <div class="t1"
             v-show="examInfo.grademethod == '01'">评分方法：最新</div>
        <div class="t1"
             v-show="examInfo.grademethod == '02'">评分方法：最高</div>
        <div class="t1"
             v-show="examInfo.grademethod == '03'">评分方法：平均</div>
        <div class="t1"
             v-show="examInfo.status == '00'">考试状态: 未开通</div>
        <div class="t1"
             v-show="examInfo.status == '01'">考试状态: 已开通</div>
        <div class="t1"
             v-show="examInfo.status == '02'">考试状态: 已提交</div>
        <div class="t1"
             v-show="examInfo.status == '03'">考试状态: 已通过</div>
        <div class="t1"
             v-show="examInfo.status == '04'">考试状态: 未通过</div>
      </div>
    </div>

    <div class="examNum">
      <div style="color: #4076f6"
           v-if="examInfo.status != '03' && examInfo.status != '04'">考试成绩: 无&emsp;考试次数: {{examInfo.examNum}}次</div>
      <div style="color: #4076f6"
           v-else>考试成绩: {{examInfo.grade.toFixed(1)}}分&emsp;考试次数: {{examInfo.examNum}}次</div>
      <div style="color: #666; margin-top: 3px">考试时间: {{examInfo.timeopen}}-{{examInfo.timeclose}}</div>
      <div class="btnexam">
        <div></div>
        <div class="btnBox">
          <div class="btn"
               style="background-color: #fa9459 !important"
               @click="examJj(examInfo.description)">考试须知</div>
          <div class="btn"
               @click="goExam(examInfo)">参与考试</div>
        </div>
      </div>
    </div>

    <div style="margin: 20px 0;padding: 0 15px;">
      考试记录：
    </div>

    <div class="jlList">
      <div class="jl"
           v-for="msg in examInfo.examUQDetailList"
           :key="msg.uqdId">
        <div class="j1">考试成绩：{{Number(msg.grade).toFixed(1)}}分</div>
        <div class="j1">交卷时间：{{msg.readTime}}</div>
        <div class="j1"
             v-show="msg.state == '01'">试卷状态:考试中</div>
        <div class="j1"
             v-show="msg.state == '02'">试卷状态:已保存</div>
        <div class="j1"
             v-show="msg.state == '03'">试卷状态:已交卷</div>
        <div class="j1"
             v-show="msg.state == '04'">试卷状态:批改中</div>
        <div class="j1"
             v-show="msg.state == '05'">试卷状态:已批改</div>
        <div class="j1">批卷时间：{{msg.readTime}}</div>
        <div class="j1">所属试卷名称：{{msg.paperName}}</div>
      </div>
      <van-empty description="暂无记录" v-if="examInfo.examUQDetailList.length == 0"/>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

import { toExamUQDetail, findUQState } from '@/api/exam.js';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      examInfo: {},
      examShow: false
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    examJj(msg) {
      this.$utils.showTitlefirm('考试须知', msg);
    },
    //参与考试
    goExam(item) {
      //判断该用户是否能考试
      findUQState({ uqId: item.uqId }).then(res => {
        console.log(res.data.data.sta);
        if (res.data.data.sta == '01') {
          this.$router.push({
            path: '/studyExam',
            query: {
              id: res.data.data.uqId
            }
          });
        } else {
          this.$utils.showTitlefirm('温馨提示', '您无法参加该考试！');
        }
      });
    },
    toExamUQDetail() {
      let data = {
        classId: this.$route.query.classId,
        quizType: '03'
      };
      toExamUQDetail(data).then(res => {
        this.examInfo = res.data.data;
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.toExamUQDetail();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.examInfo {
  background: #fff;
  padding: 10px;
  display: flex;
  .fm {
    width: 117px;
    height: 118px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .t1 {
    font-size: 13px;
    color: #666;
    margin-bottom: 3px;
  }
}

.examNum {
  background: #fff;
  font-size: 13px;
  padding: 10px;
  .btnexam {
    display: flex;
    justify-content: space-between;
    .btnBox {
      margin-top: 10px;
      display: flex;
      .btn {
        width: 76px;
        height: 32px;
        background: #2a70f2;
        border-radius: 8px;
        text-align: center;
        line-height: 32px;
        color: #fff;
        margin-right: 20px;
      }
    }
  }
}

.jlList {
  background: #fff;
  padding: 15px;
  .jl {
    margin-top: 15px;
    padding-bottom: 10px;
    border-bottom: 1px dashed #ccc;
    .j1 {
      color: #ccc;
      font-size: 14px;
      margin-bottom: 5px;
    }
  }
  .jl:last-child {
    border: 0 !important;
  }
}
</style>
